var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.single
        ? _c(
            "select-content-single",
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  disabled: _vm.disabled,
                  placeholder: _vm.$attrs.placeholder,
                },
                on: { change: _vm.change },
                nativeOn: {
                  click: function ($event) {
                    return _vm.showOuter.apply(null, arguments)
                  },
                },
              },
              "select-content-single",
              _vm.selectContentOptions,
              false
            )
          )
        : _c(
            "select-content-multiple",
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  disabled: _vm.disabled,
                  placeholder: _vm.$attrs.placeholder,
                },
                on: { change: _vm.change },
                nativeOn: {
                  click: function ($event) {
                    return _vm.showOuter.apply(null, arguments)
                  },
                },
              },
              "select-content-multiple",
              _vm.selectContentOptions,
              false
            )
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }